import { defineComponent, ref, onMounted, computed, inject } from "vue";
import { Customer } from "@/models/Customer";
import { useAsyncSpinner } from "@/services/Spinner";
import { MemberApi } from "@/services/Api";
import CustomerDetails from "@/components/CustomerDetails.vue";
import CustomerDetailsMyPagesEdit from "@/components/CustomerDetailsMyPagesEdit.vue";
import BoxWithTitle from "@/components/BoxWithTitle.vue";
import ChangePasswordForm from "@/components/ChangePasswordForm.vue";
import AlternativeDelivery from "@/components/AlternativeDelivery.vue";

export default defineComponent({
  components: {
    CustomerDetails,
    CustomerDetailsMyPagesEdit,
    BoxWithTitle,
    ChangePasswordForm,
    AlternativeDelivery
  },
  data() {
    return{
      showPricesAsB2b:false
    }
  },
  mounted() {
    this.showPricesAsB2b = inject<boolean>("show-prices-as-b2b", false);
  },
  setup() {
    const customer = ref<Customer | null>(null);
    const isEditModeUser = ref(false);
    const isEditModePwd = ref(false);
    const pwdChangedMessage = ref<string>();

    const getCustomer = async (): Promise<void> => {
      await useAsyncSpinner(async () => {
        const fetchedCustomer = await MemberApi.getCustomer();
        customer.value = fetchedCustomer;
      });
    };

    const toggleEditModeUser = (): void => {
      isEditModeUser.value = !isEditModeUser.value;

      const toggleButton = document.getElementById('btn-edit-user-data');
      if (toggleButton) {
        toggleButton.className = isEditModeUser.value
          ? "my-details-container__toggle__button-close"
          : "my-details-container__toggle__button-edit";
      }
    }

    const toggleEditModePwd = (): void => {
      isEditModePwd.value = !isEditModePwd.value;

      const toggleButton = document.getElementById('btn-edit-pwd-data');
      if (toggleButton) {
        toggleButton.className = isEditModePwd.value
          ? "my-details-container__toggle__button-close"
          : "my-details-container__toggle__button-edit";
      }
    }

    const setPwdChangedMessage = (message: string): void => {
      toggleEditModePwd();
      pwdChangedMessage.value = message;
    };

    onMounted(async () => {
      await getCustomer();
    });

    const customerData = computed(() => customer.value);

    return {
      customer: customerData,
      isEditModeUser,
      isEditModePwd,
      pwdChangedMessage,
      toggleEditModeUser,
      toggleEditModePwd,
      setPwdChangedMessage
    };
  },
});